<app-custom-breadcrumb [crumbs]="breadcrumbs"></app-custom-breadcrumb>
<div class="flex items-center gap-3 my-3">
  <app-back-option-section [loading]="loading"></app-back-option-section>
  <h2>{{ reservationId ? 'Edit Transfer Booking' : 'Add New Transfer Booking' }}</h2>
</div>
<div *ngIf="emailContent" class="fixed top-56 right-10 z-20">
  <button nz-button nzType="primary" nzGhost class="outline-button" (click)="openEmailContentDrawer()">
    Preview Email
  </button>
</div>

<div [ngClass]="!loading ? 'block' : 'hidden'">
  <section id="booking-details">
    <nz-card>
      <div>
        <h5 class="text-primary">Booking Details</h5>

        <span *ngIf="tempBooking" class="text-primary text-sm my-4">Agent is '{{
          tempBooking?.booking?.bookingDetails?.agent }}'. Check the system agents and select or add new agent.</span>
        <form nz-form [formGroup]="transferForm">
          <div formGroupName="bookingDetails">
            <div class="mt-2 grid sm:grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-2">
              <div>
                <nz-form-item class="grid grid-flow-row content-start">
                  <nz-form-label nzRequired>Booking Received Date</nz-form-label>
                  <nz-form-control [nzErrorTip]="bookingReceivedDate">
                    <nz-date-picker class="w-full" formControlName="bookingReceivedDate" [nzDisabledDate]="disabledDate"
                      placeHolder="Select date"></nz-date-picker>
                  </nz-form-control>
                  <ng-template #bookingReceivedDate>
                    <span *ngIf="transferForm.get('bookingDetails.bookingReceivedDate').hasError('required')">Please
                      enter Booking Received Date</span>
                  </ng-template>
                </nz-form-item>
              </div>

              <div>
                <nz-form-item class="grid grid-flow-row content-start">
                  <nz-form-label nzRequired>Booking Type</nz-form-label>
                  <nz-form-control [nzErrorTip]="bookingType">
                    <nz-select formControlName="bookingType" nzPlaceHolder="Select Type">
                      <nz-option nzLabel="Through Agent" nzValue="Through Agent"></nz-option>
                      <nz-option nzLabel="Direct Booking" nzValue="Direct Booking"></nz-option>
                    </nz-select>
                  </nz-form-control>
                  <ng-template #bookingType>
                    <span *ngIf="transferForm.get('bookingDetails.bookingType').hasError('required')">Please select
                      Booking Type</span>
                  </ng-template>
                </nz-form-item>
              </div>
              <div>
                <nz-form-item class="grid grid-flow-row content-start"
                  *ngIf="transferForm.get('bookingDetails.bookingType').value === 'Through Agent'">
                  <nz-form-label nzRequired>Agent</nz-form-label>
                  <nz-form-control [nzErrorTip]="agent">
                    <nz-select nzPlaceHolder="Select Agent" nzAllowClear nzShowSearch
                      (nzOnSearch)="onSearchAgent($event)" formControlName="agent">
                      <nz-option *ngFor="let op of agentOptionsFiler" nzValue="{{op._id}}"
                        nzLabel="{{op.name}} | {{op.email}}"></nz-option>
                    </nz-select>
                  </nz-form-control>
                  <ng-template #agent>
                    <span *ngIf="transferForm.get('bookingDetails.agent').hasError('required')">Please select
                      Agent</span>
                  </ng-template>
                </nz-form-item>
              </div>
              <div>
                <nz-form-item *ngIf="transferForm.get('bookingDetails.bookingType').value === 'Through Agent'"
                  class="grid  content-start">
                  <label class="p-2"></label>
                  <nz-form-control>
                    <button class="outline-button mt-5   w-40  btn-add-agent" nz-button nzType="default"
                      (click)="showAddAgentPopup()">Add New Agent
                    </button>
                  </nz-form-control>
                </nz-form-item>
              </div>
            </div>
            <div class="mt-2 grid sm:grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-2">
              <nz-form-item *ngIf="transferForm.get('bookingDetails.bookingType').value === 'Through Agent'"
                class="grid grid-flow-row content-start">
                <nz-form-label nzRequired>Booking Reference</nz-form-label>
                <nz-form-control [nzErrorTip]="bookingReference">
                  <input PlaceHolder="Enter Reference Number" formControlName="bookingReference" nz-input type="text" />
                </nz-form-control>
                <ng-template #bookingReference>
                  <span *ngIf="transferForm.get('bookingDetails.bookingReference').hasError('required')">Please enter
                    booking reference
                  </span>
                </ng-template>
              </nz-form-item>

              <nz-form-item class="grid grid-flow-row content-start">
                <nz-form-label nzRequired>Booking Category</nz-form-label>
                <nz-form-control [nzErrorTip]="bookingCategory">
                  <nz-select formControlName="bookingCategory" nzPlaceHolder="Select Booking Category">
                    <nz-option nzLabel="Arrival" nzValue="Arrival"></nz-option>
                    <nz-option nzLabel="Departure" nzValue="Departure"></nz-option>
                  </nz-select>
                </nz-form-control>
                <ng-template #bookingCategory>
                  <span *ngIf="transferForm.get('bookingDetails.bookingCategory').hasError('required')">Please select
                    booking Category</span>
                </ng-template>
              </nz-form-item>
            </div>
          </div>
        </form>
      </div>
    </nz-card>
  </section>


  <section id="Tour-details" class="mt-10" *ngIf="transferForm.get('bookingDetails.bookingCategory').value !== null">
    <nz-card>
      <div>
        <h5 class="text-primary">Tour Details</h5>
        <span *ngIf="tempBooking" class="text-primary text-sm mt-4">* Customer is '{{ tempBooking?.tourDetails?.customer
          }}'. Check the system customers and select or add new customer.</span>
        <br>
        <span *ngIf="tempBooking" class="text-primary text-sm mb-4">* Vehicle Category is '{{
          tempBooking?.tourDetails?.vehicleCategory }}'. Check the system vehicle categories and select one.</span>
        <form nz-form [formGroup]="transferForm">
          <div formGroupName="tourDetails" class="mt-5 grid sm:grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-3">


            <nz-form-item class="grid grid-flow-row content-start">
              <nz-form-label nzRequired>Customer</nz-form-label>
              <nz-form-control [nzErrorTip]="customer">
                <nz-select nzPlaceHolder="Select Customer" formControlName="customer" nzAllowClear nzShowSearch
                  (nzOnSearch)="onSearchCustomer($event)">
                  <nz-option *ngFor="let op of customerOptionsFilter" nzValue="{{op._id}}"
                    nzLabel="{{op.name}}"></nz-option>
                </nz-select>
              </nz-form-control>
              <ng-template #customer>
                <span *ngIf="transferForm.get('tourDetails.customer').hasError('required')">Please select
                  Customer</span>
              </ng-template>
            </nz-form-item>


            <nz-form-item class="grid grid-flow-row content-start">

              <nz-form-control>
                <button (click)="showAddCustomerPopup()" (keydown.enter)="$event.preventDefault()"
                  class="outline-button  mt-9 customer-button" nz-button nzType="default">
                  Add New
                  Customer
                </button>
              </nz-form-control>
            </nz-form-item>
          </div>

          <nz-divider class="w-full"></nz-divider>

          <div formGroupName="tourDetails"
            *ngIf="transferForm.get('bookingDetails.bookingCategory').value === 'Arrival'"
            class="mt-5 grid sm:grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-3">

            <nz-form-item *ngIf="transferForm.get('bookingDetails.bookingCategory').value === 'Arrival'"
              class="grid grid-flow-row content-start">
              <nz-form-label nzRequired>Arrival Flight Number</nz-form-label>
              <nz-form-control [nzErrorTip]="arrivalFlightNumber">
                <input nz-input type="text" formControlName="arrivalFlightNumber" PlaceHolder="Enter Number" />
              </nz-form-control>
              <ng-template #arrivalFlightNumber>
              </ng-template>
            </nz-form-item>

            <nz-form-item class="grid grid-flow-row content-start">
              <nz-form-label nzRequired>Arrival Flight Time</nz-form-label>
              <nz-form-control [nzErrorTip]="arrivalFlightTime">
                <nz-time-picker nzPlaceHolder="Select Time" class="w-full" formControlName="arrivalFlightTime"
                  [nzFormat]="'HH:mm'"></nz-time-picker>
              </nz-form-control>
              <ng-template #arrivalFlightTime>
                <span *ngIf="transferForm.get('tourDetails.arrivalFlightTime').hasError('required')">Please enter
                  Arrival Flight Time</span>
                <span *ngIf="transferForm.get('tourDetails.arrivalFlightTime').hasError('maxlength')">Maximum length
                  exceeded for Arrival Flight Time</span>
              </ng-template>
            </nz-form-item>


            <nz-form-item class="grid grid-flow-row content-start">
              <nz-form-label nzRequired>Arrival Flight Date</nz-form-label>
              <nz-form-control [nzErrorTip]="arrivalFlightDate">
                <nz-date-picker class="w-full" [nzDisabledDate]="disabledDate"
                  formControlName="arrivalFlightDate"></nz-date-picker>
              </nz-form-control>
              <ng-template #arrivalFlightDate>
                <span *ngIf="transferForm.get('tourDetails.arrivalFlightDate').hasError('required')">Please enter
                  Arrival Flight Date</span>
              </ng-template>
            </nz-form-item>

          </div>

          <div formGroupName="tourDetails"
            *ngIf="transferForm.get('bookingDetails.bookingCategory').value === 'Arrival'"
            class="mt-5 grid sm:grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-3">

            <nz-form-item class="grid grid-flow-row content-start">
              <nz-form-label nzRequired>Pick Up Time</nz-form-label>
              <nz-form-control [nzErrorTip]="pickUpTime">
                <nz-time-picker class="w-full" nzPlaceHolder="Select Time" formControlName="pickUpTime"
                  [nzFormat]="'HH:mm'"></nz-time-picker>
              </nz-form-control>
              <ng-template #pickUpTime>
                <span *ngIf="transferForm.get('tourDetails.pickUpTime').hasError('required')">Please enter Pick Up
                  Time</span>
              </ng-template>
            </nz-form-item>

            <nz-form-item class="grid grid-flow-row content-start">
              <nz-form-label nzRequired>Pick Up Location</nz-form-label>
              <nz-form-control [nzErrorTip]="pickUpLocation">
                <input nz-input type="text" formControlName="pickUpLocation" PlaceHolder="Enter Location" />
              </nz-form-control>
              <ng-template #pickUpLocation>
                <span *ngIf="transferForm.get('tourDetails.pickUpLocation').hasError('required')">Please enter Pick Up
                  Location</span>
              </ng-template>
            </nz-form-item>

            <nz-form-item class="grid grid-flow-row content-start">
              <nz-form-label nzRequired>Drop Off Location</nz-form-label>
              <nz-form-control [nzErrorTip]="dropOffLocation">
                <input nz-input type="text" formControlName="dropOffLocation" PlaceHolder="Enter Location" />
              </nz-form-control>
              <ng-template #dropOffLocation>
                <span *ngIf="transferForm.get('tourDetails.dropOffLocation').hasError('required')">Please enter Drop Off
                  Location</span>
              </ng-template>
            </nz-form-item>

            <nz-form-item class="grid grid-flow-row content-start">
              <nz-form-label nzRequired>Drop Off City</nz-form-label>
              <nz-form-control [nzErrorTip]="dropOffCity">
                <input nz-input type="text" formControlName="dropOffCity" PlaceHolder="Enter Location" />
              </nz-form-control>
              <ng-template #dropOffCity>
                <span *ngIf="transferForm.get('tourDetails.dropOffCity').hasError('required')">Please enter Drop Off
                  City</span>
              </ng-template>
            </nz-form-item>

          </div>

          <div formGroupName="tourDetails"
            *ngIf="transferForm.get('bookingDetails.bookingCategory').value === 'Arrival'"
            class="mt-5 grid sm:grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-3">

            <nz-form-item class="grid grid-flow-row content-start">
              <nz-form-label nzRequired>No. Of Adults</nz-form-label>
              <nz-form-control [nzErrorTip]="noOfAdults">
                <input nz-input type="number" formControlName="noOfAdults" PlaceHolder="Enter Number" />
              </nz-form-control>
              <ng-template #noOfAdults>
                <span *ngIf="transferForm.get('tourDetails.noOfAdults').hasError('required')">Please enter No of
                  Adults</span>
              </ng-template>
            </nz-form-item>

            <nz-form-item class="grid grid-flow-row content-start">
              <nz-form-label nzRequired>No. Of Children</nz-form-label>
              <nz-form-control [nzErrorTip]="noOfChildren">
                <input nz-input type="number" formControlName="noOfChildren" PlaceHolder="Enter Number" />
              </nz-form-control>
              <ng-template #noOfChildren>
                <span *ngIf="transferForm.get('tourDetails.noOfChildren').hasError('required')">Please enter No of
                  Children</span>
              </ng-template>
            </nz-form-item>

            <nz-form-item class="grid grid-flow-row content-start">
              <nz-form-label nzRequired>No. Of Infants</nz-form-label>
              <nz-form-control [nzErrorTip]="noOfInfants">
                <input nz-input type="number" formControlName="noOfInfants" PlaceHolder="Enter Number" />
              </nz-form-control>
              <ng-template #noOfInfants>
                <span *ngIf="transferForm.get('tourDetails.noOfInfants').hasError('required')">Please enter No of
                  Infants</span>
              </ng-template>
            </nz-form-item>

            <nz-form-item class="grid grid-flow-row content-start">
              <nz-form-label nzRequired>Number Of Passengers</nz-form-label>
              <nz-form-control [nzErrorTip]="noOfPassengers">
                <input nz-input type="number" formControlName="noOfPassengers" PlaceHolder="Enter Number" />
              </nz-form-control>
              <ng-template #noOfPassengers>
                <span *ngIf="transferForm.get('tourDetails.noOfPassengers').hasError('required')">Please enter No of
                  Passengers</span>
              </ng-template>
            </nz-form-item>

          </div>

          <div formGroupName="tourDetails"
            *ngIf="transferForm.get('bookingDetails.bookingCategory').value === 'Arrival'"
            class="mt-5 grid sm:grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-3">

            <nz-form-item class="grid grid-flow-row content-start">
              <nz-form-label nzRequired>Number Of Luggage's</nz-form-label>
              <nz-form-control [nzErrorTip]="noOfLuggages">
                <input nz-input type="number" formControlName="noOfLuggages" PlaceHolder="Enter Number" />
              </nz-form-control>
              <ng-template #noOfLuggages>
                <span *ngIf="transferForm.get('tourDetails.noOfLuggages').hasError('required')">Please enter No of
                  Luggage</span>
              </ng-template>
            </nz-form-item>

            <nz-form-item class="grid grid-flow-row content-start">
              <nz-form-label nzRequired>Vehicle Category</nz-form-label>
              <nz-form-control [nzErrorTip]="vehicleCategory">
                <nz-select nzAllowClear nzShowSearch (nzOnSearch)="onSearchCategory($event)"
                  nzPlaceHolder="Select Vehicle Category" formControlName="vehicleCategory">
                  <nz-option *ngFor="let category of vehicleCategoriesArrivalFiltered" [nzValue]="category._id"
                    [nzLabel]="category.name"></nz-option>
                </nz-select>
              </nz-form-control>
              <ng-template #vehicleCategory>
                <span *ngIf="transferForm.get('tourDetails.vehicleCategory').hasError('required')">Please select Vehicle
                  Category</span>
              </ng-template>
            </nz-form-item>

            <nz-form-item class="grid grid-flow-row content-start">
              <nz-form-label>Distance to Destination</nz-form-label>
              <nz-form-control [nzErrorTip]="distanceToDestination">
                <nz-input-group nzAddOnAfter="Km">
                  <input nz-input type="number" [min]="0" formControlName="distanceToDestination"
                    placeholder="Enter Number" />
                </nz-input-group>
              </nz-form-control>
              <ng-template #distanceToDestination>
              </ng-template>
            </nz-form-item>

            <nz-form-item class="grid grid-flow-row content-start">
              <nz-form-label nzRequired>Arrival End Date</nz-form-label>
              <nz-form-control [nzErrorTip]="EndDateArrival">
                <nz-date-picker class="w-full" [nzDisabledDate]="disabledDate"
                  formControlName="arrivalEndDate"></nz-date-picker>
              </nz-form-control>
              <ng-template #EndDateArrival>
              </ng-template>
            </nz-form-item>

            <nz-form-item class="grid grid-flow-row content-start">
              <nz-form-label nzRequired>Arrival End Time</nz-form-label>
              <nz-form-control [nzErrorTip]="EndTime">
                <nz-time-picker class="w-full" nzPlaceHolder="Select Time" formControlName="arrivalEndTime"
                  [nzFormat]="'HH:mm'"></nz-time-picker>
              </nz-form-control>
              <ng-template #EndTime>
                <span *ngIf="transferForm.get('tourDetails.pickUpTime').hasError('required')">Please End Time</span>
              </ng-template>
            </nz-form-item>


          </div>

          <nz-divider class="w-full"></nz-divider>

          <div formGroupName="tourDetails"
            *ngIf="transferForm.get('bookingDetails.bookingCategory').value === 'Arrival'"
            class="mt-5 grid sm:grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-3">
            <div class="flex gap-2" style="align-items: center;">
              <label nz-checkbox formControlName="departureCheck"></label>
              <nz-form-label>Include Departure</nz-form-label>
            </div>
          </div>

          <div formGroupName="tourDetails">

            <div formGroupName="departureTourDetails"
              *ngIf="transferForm.get('bookingDetails.bookingCategory').value === 'Departure'||transferForm.get('tourDetails.departureCheck').value === true"
              class="mt-5 grid sm:grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-3">

              <nz-form-item class="grid grid-flow-row content-start">
                <nz-form-label>Departure Flight Number</nz-form-label>
                <nz-form-control [nzErrorTip]="departureFlightNumberDep">
                  <input nz-input type="text" formControlName="departureFlightNumber" PlaceHolder="Enter Number" />
                </nz-form-control>
                <ng-template #departureFlightNumberDep>
                </ng-template>
              </nz-form-item>

              <nz-form-item class="grid grid-flow-row content-start">
                <nz-form-label nzRequired>Departure Flight Time</nz-form-label>
                <nz-form-control [nzErrorTip]="departureFlightTimeDep">
                  <nz-time-picker class="w-full" nzPlaceHolder="Select Time" formControlName="departureFlightTime"
                    [nzFormat]="'HH:mm'"></nz-time-picker>
                </nz-form-control>
                <ng-template #departureFlightTimeDep>
                </ng-template>
              </nz-form-item>

              <nz-form-item class="grid grid-flow-row content-start">
                <nz-form-label nzRequired>Departure Flight Date</nz-form-label>
                <nz-form-control [nzErrorTip]="departureFlightDateDep">
                  <nz-date-picker class="w-full" [nzDisabledDate]="disabledDate"
                    formControlName="departureFlightDate"></nz-date-picker>
                </nz-form-control>
                <ng-template #departureFlightDateDep>
                </ng-template>
              </nz-form-item>

            </div>

            <div formGroupName="departureTourDetails"
              *ngIf="transferForm.get('bookingDetails.bookingCategory').value === 'Departure'||transferForm.get('tourDetails.departureCheck').value === true"
              class="mt-5 grid sm:grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-3">

              <nz-form-item class="grid grid-flow-row content-start">
                <nz-form-label nzRequired>Pick Up Time</nz-form-label>
                <nz-form-control [nzErrorTip]="pickUpTimeDep">
                  <nz-time-picker class="w-full" nzPlaceHolder="Select Time" formControlName="departurePickUpTime"
                    [nzFormat]="'HH:mm'"></nz-time-picker>
                </nz-form-control>
                <ng-template #pickUpTimeDep>
                </ng-template>
              </nz-form-item>

              <nz-form-item class="grid grid-flow-row content-start">
                <nz-form-label nzRequired>Pick Up Location</nz-form-label>
                <nz-form-control [nzErrorTip]="pickUpLocationDep">
                  <input nz-input type="text" formControlName="departurePickUpLocation" PlaceHolder="Enter Location" />
                </nz-form-control>
                <ng-template #pickUpLocationDep>
                </ng-template>
              </nz-form-item>

              <nz-form-item class="grid grid-flow-row content-start">
                <nz-form-label nzRequired>Drop Off Location</nz-form-label>
                <nz-form-control [nzErrorTip]="dropOffLocationDep">
                  <input nz-input type="text" formControlName="departureDropOffLocation" PlaceHolder="Enter Location" />
                </nz-form-control>
                <ng-template #dropOffLocationDep>
                </ng-template>
              </nz-form-item>

              <nz-form-item class="grid grid-flow-row content-start">
                <nz-form-label nzRequired>Drop Off City</nz-form-label>
                <nz-form-control [nzErrorTip]="dropOffCityDep">
                  <input nz-input type="text" formControlName="departureDropOffCity" PlaceHolder="Enter Location" />
                </nz-form-control>
                <ng-template #dropOffCityDep>
                </ng-template>
              </nz-form-item>

            </div>

            <div formGroupName="departureTourDetails"
              *ngIf="transferForm.get('bookingDetails.bookingCategory').value === 'Departure'||transferForm.get('tourDetails.departureCheck').value === true"
              class="mt-5 grid sm:grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-3">

              <nz-form-item class="grid grid-flow-row content-start">
                <nz-form-label nzRequired>No. Of Adults</nz-form-label>
                <nz-form-control [nzErrorTip]="noOfAdultsDep">
                  <input nz-input type="number" formControlName="departureNoOfAdults" PlaceHolder="Enter Number" />
                </nz-form-control>
                <ng-template #noOfAdultsDep>
                </ng-template>
              </nz-form-item>

              <nz-form-item class="grid grid-flow-row content-start">
                <nz-form-label nzRequired>No. Of Children</nz-form-label>
                <nz-form-control [nzErrorTip]="noOfChildrenDep">
                  <input nz-input type="number" formControlName="departureNoOfChildren" PlaceHolder="Enter Number" />
                </nz-form-control>
                <ng-template #noOfChildrenDep>
                </ng-template>
              </nz-form-item>

              <nz-form-item class="grid grid-flow-row content-start">
                <nz-form-label nzRequired>No. Of Infants</nz-form-label>
                <nz-form-control [nzErrorTip]="noOfInfantsDep">
                  <input nz-input type="number" formControlName="departureNoOfInfants" PlaceHolder="Enter Number" />
                </nz-form-control>
                <ng-template #noOfInfantsDep>
                </ng-template>
              </nz-form-item>

              <nz-form-item class="grid grid-flow-row content-start">
                <nz-form-label nzRequired>Number Of Passengers</nz-form-label>
                <nz-form-control [nzErrorTip]="noOfPassengersDep">
                  <input nz-input type="number" formControlName="departureNoOfPassengers" PlaceHolder="Enter Number" />
                </nz-form-control>
                <ng-template #noOfPassengersDep>
                </ng-template>
              </nz-form-item>


            </div>

            <div formGroupName="departureTourDetails"
              *ngIf="transferForm.get('bookingDetails.bookingCategory').value === 'Departure'||transferForm.get('tourDetails.departureCheck').value === true"
              class="mt-5 grid sm:grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-3">

              <nz-form-item class="grid grid-flow-row content-start">
                <nz-form-label nzRequired>Number Of Luggage's</nz-form-label>
                <nz-form-control [nzErrorTip]="noOfLuggagesDep">
                  <input nz-input type="number" formControlName="departureNoOfLuggages" PlaceHolder="Enter Number" />
                </nz-form-control>
                <ng-template #noOfLuggagesDep>
                </ng-template>
              </nz-form-item>

              <nz-form-item class="grid grid-flow-row content-start">
                <nz-form-label nzRequired>Vehicle Category</nz-form-label>
                <nz-form-control [nzErrorTip]="vehicleCategoryDep">
                  <nz-select nzAllowClear nzShowSearch (nzOnSearch)="onSearchDepCategory($event)"
                    nzPlaceHolder="Select Vehicle Category" formControlName="departureVehicleCategory">
                    <nz-option *ngFor="let category of vehicleCategoriesDepFiltered" [nzValue]="category._id"
                      [nzLabel]="category.name"></nz-option>
                  </nz-select>
                </nz-form-control>
                <ng-template #vehicleCategoryDep>
                </ng-template>
              </nz-form-item>

              <nz-form-item class="grid grid-flow-row content-start">
                <nz-form-label>Distance to Destination</nz-form-label>
                <nz-form-control [nzErrorTip]="distanceToDestinationDep">
                  <nz-input-group nzAddOnAfter="Km">
                    <input nz-input type="number" [min]="0" formControlName="departureDistanceToDestination"
                      placeholder="Enter Number" />
                  </nz-input-group>
                  <!--                  <nz-input-number [nzFormatter]="formatterDistance" style="width: 100%" [nzMin]="0"-->
                  <!--                                   [nzParser]="parserDistance" formControlName="departureDistanceToDestination"-->
                  <!--                                   PlaceHolder="Enter Number"></nz-input-number>-->
                </nz-form-control>
                <ng-template #distanceToDestinationDep>
                </ng-template>
              </nz-form-item>

              <nz-form-item class="grid grid-flow-row content-start">
                <nz-form-label nzRequired>Departure End Date</nz-form-label>
                <nz-form-control [nzErrorTip]="EndDateDep">
                  <nz-date-picker class="w-full" [nzDisabledDate]="disabledDate"
                    formControlName="departureEndDate"></nz-date-picker>
                </nz-form-control>
                <ng-template #EndDateDep>
                </ng-template>
              </nz-form-item>

              <nz-form-item class="grid grid-flow-row content-start">
                <nz-form-label nzRequired>Departure End Time</nz-form-label>
                <nz-form-control [nzErrorTip]="EndTimeDep">
                  <nz-time-picker class="w-full" nzPlaceHolder="Select Time" formControlName="departureEndTime"
                    [nzFormat]="'HH:mm'"></nz-time-picker>
                </nz-form-control>
                <ng-template #EndTimeDep>
                  <span *ngIf="transferForm.get('tourDetails.pickUpTime').hasError('required')">Please End Time</span>
                </ng-template>
              </nz-form-item>

            </div>

          </div>

        </form>
      </div>
    </nz-card>
  </section>


  <section id="arrival-allocation-details"
    *ngIf="transferForm.get('bookingDetails.bookingCategory').value === 'Arrival'" class="mt-10">
    <nz-card>
      <div>
        <h5 class="text-primary">Arrival Allocation Details</h5>
       <div class="flex items-center gap-3 mt-4">
        <button (click)="refreshVehicles()" class="px-[5px]" nz-button nzType="primary"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-rotate-cw"><path d="M21 12a9 9 0 1 1-9-9c2.52 0 4.93 1 6.74 2.74L21 8"/><path d="M21 3v5h-5"/></svg>
        </button>
        <h6 class="font-normal">Refresh before you allocate the vehicle</h6>
       </div>

        <form nz-form [formGroup]="transferForm">

          <div formGroupName="arrivalDetails" class="mt-5 grid sm:grid-cols-1 md:grid-cols-2 xl:grid-cols-2 gap-3">
            <div class="grid sm:grid-cols-1 md:grid-cols-2 xl:grid-cols-2 gap-3">

              <nz-form-item class="grid grid-flow-row content-start">
                <nz-form-label formControlName="allocatedVehicle" nzRequired>Allocated Vehicle</nz-form-label>
                <nz-form-control [nzErrorTip]="allocatedVehicleArrival">
                  <nz-select nzPlaceHolder="Select Vehicle" nzAllowClear nzShowSearch
                    (nzOnSearch)="onSearchAllocatedVehicle($event)" (ngModelChange)="getFleetVehicle($event)"
                    formControlName="allocatedVehicle">
                    <nz-option *ngFor="let op of fleetsOptionsFiltered" nzValue="{{op._id}}" [nzLabel]="op.vehicleName"
                      [nzDisabled]="disableArrivalSelectedVehicle(op._id)"></nz-option>
                  </nz-select>
                </nz-form-control>
                <ng-template #allocatedVehicleArrival>
                </ng-template>
                <p class="my-2 text-primary text-sm" *ngIf="fleetsFetching">Loading...</p>
              </nz-form-item>


            </div>

            <div class="grid sm:grid-cols-1 md:grid-cols-2 xl:grid-cols-2 gap-3">

              <nz-form-item class="grid grid-flow-row content-start">
                <nz-form-label nzRequired>Driver Category</nz-form-label>
                <nz-form-control [nzErrorTip]="driverCategoryArrival">
                  <nz-select nzPlaceHolder="Select Vehicle" formControlName="driverCategory"
                    (ngModelChange)="getDriverOptions($event)">
                    <nz-option nzLabel="SR Driver" nzValue="SR_DRIVER"></nz-option>
                    <nz-option nzLabel="Outsourced driver" nzValue="OUTSOURCE_DRIVER"></nz-option>
                  </nz-select>
                </nz-form-control>
                <ng-template #driverCategoryArrival>
                </ng-template>
              </nz-form-item>

              <div></div>

              <nz-form-item class="grid grid-flow-row content-start"
                *ngIf="transferForm.get('arrivalDetails.driverCategory').value !== null">
                <div class="flex items-center gap-3 mt-4">
                  <button (click)="refreshDrivers()" class="px-[5px]" nz-button nzType="primary"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-rotate-cw"><path d="M21 12a9 9 0 1 1-9-9c2.52 0 4.93 1 6.74 2.74L21 8"/><path d="M21 3v5h-5"/></svg>
                  </button>
                  <h6 class="font-normal">Refresh before you allocate the driver</h6>
                 </div>
                <nz-form-label nzRequired>Allocate Driver</nz-form-label>
                <nz-form-control [nzErrorTip]="allocateDriverArrival">
                  <nz-select nzPlaceHolder="Select Driver" formControlName="allocateDriver" nzAllowClear nzShowSearch
                    (nzOnSearch)="onSearchDriver($event)"
                    (ngModelChange)="getSupplierVehiclesArrival($event);getDriver($event)">
                    <!--                    <nz-option *ngFor="let op of driverOptionsFiltered" nzValue="{{op._id}}"-->
                    <!--                               nzLabel="{{op.fullName}}"></nz-option>-->
                    <nz-option nzCustomContent *ngFor="let op of driverOptionsFiltered" nzValue="{{op._id}}"
                      [nzLabel]="op.fullName">
                      <div class="flex items-center driver-availability-status">
                        <div [nz-tooltip]="getDriverAvailabilityIcon(op.driverAvailability)?.label"
                          class="vehicle-status-mark {{getDriverAvailabilityIcon(op.driverAvailability)?.bgColor}}">
                        </div>
                        <div>{{op.fullName}}</div>
                      </div>
                    </nz-option>
                  </nz-select>
                </nz-form-control>
                <ng-template #allocateDriverArrival>
                </ng-template>
                <p class="my-2 text-primary text-sm" *ngIf="driversFetching">Loading...</p>
              </nz-form-item>

              <nz-form-item class="grid grid-flow-row content-start"
                *ngIf="transferForm.get('arrivalDetails.driverCategory').value !== null">
                <nz-form-control>
                  <button (click)="showAddDriverPopup()" (keydown.enter)="$event.preventDefault()"
                    class="outline-button mt-9 custom-btn_add" nz-button nzType="default">Add New
                    Driver
                  </button>
                </nz-form-control>
              </nz-form-item>


              <nz-form-item class="grid grid-flow-row content-start"
                *ngIf="transferForm.get('arrivalDetails.driverCategory').value === 'OUTSOURCE_DRIVER'">
                <nz-form-label nzRequired>Allocate Vehicle</nz-form-label>
                <nz-form-control [nzErrorTip]="allocateVehicleArrival">
                  <nz-select nzPlaceHolder="Select Vehicle" nzAllowClear nzShowSearch
                    (nzOnSearch)="onSearchSupplierVehicle($event)" formControlName="allocateVehicle"
                    (ngModelChange)="getSupplierVehicle($event)">
                    <nz-option *ngFor="let op of supplierVehicleOptionsArrivalFiltered" nzValue="{{op?._id}}"
                      nzLabel="{{op?.registerNumber}} | {{op?.vehicleModel}}"></nz-option>
                  </nz-select>
                </nz-form-control>
                <ng-template #allocateVehicleArrival>
                </ng-template>
                <p class="my-2 text-primary text-sm" *ngIf="supplierVehiclesFetching">Loading...</p>
              </nz-form-item>

              <nz-form-item class="grid grid-flow-row content-start"
                *ngIf="transferForm.get('arrivalDetails.driverCategory').value === 'OUTSOURCE_DRIVER'">
                <nz-form-control>
                  <button (click)="showAddVehiclePopup()"
                    [disabled]="this.transferForm.get('arrivalDetails.allocateDriver').value === null"
                    (keydown.enter)="$event.preventDefault()" class="outline-button mt-9" nz-button nzType="default">Add
                    New
                    Vehicle
                  </button>
                </nz-form-control>
              </nz-form-item>

              <nz-form-item class="grid grid-flow-row content-start"
                *ngIf="transferForm.get('arrivalDetails.driverCategory').value === 'OUTSOURCE_DRIVER'">
                <nz-form-label nzRequired>Outsourced Rate</nz-form-label>
                <nz-form-control [nzErrorTip]="OutsourcedArrival">
                  <nz-input-number-group [nzAddOnAfter]="depositAddOnAfterTemplate">
                    <nz-input-number formControlName="outsourcedRate" [nzPlaceHolder]="'Enter rate'" [nzStep]="1"
                      [nzMin]="0"></nz-input-number>
                  </nz-input-number-group>
                  <ng-template #depositAddOnAfterTemplate>
                    <nz-select formControlName="outsourcedRateCurrency" [nzPlaceHolder]="'...'" style="width: 75px">
                      <nz-option *ngFor="let op of currencyOptions" [nzValue]="op._id"
                        [nzLabel]="op.currencyCode"></nz-option>
                    </nz-select>
                  </ng-template>
                </nz-form-control>
                <ng-template #OutsourcedArrival>
                </ng-template>
              </nz-form-item>

            </div>

            <div class="grid sm:grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-3" style="min-height: 200px">

              <div *ngIf="transferForm.get('arrivalDetails.driverCategory').value !== 'OUTSOURCE_DRIVER'">
                <div class="sub-section" style="height: 100%">
                  <img width="90%" [src]="this.arrivalVehicle.image" alt="image">
                </div>
              </div>

              <div *ngIf="transferForm.get('arrivalDetails.driverCategory').value !== 'OUTSOURCE_DRIVER'">
                <div style="height: 100%">
                  <div class="mb-5 mt-5">
                    <p class="subject-name">Registration Number</p>
                    <p class="subject-data">{{ this.arrivalVehicle.registrationNo }}</p>
                  </div>
                </div>
              </div>

              <div *ngIf="transferForm.get('arrivalDetails.driverCategory').value !== 'OUTSOURCE_DRIVER'">
                <div style="height: 100%">
                  <div class="mb-5 mt-5">
                    <p class="subject-name">No. Of Seats</p>
                    <p class="subject-data">{{ this.arrivalVehicle.seats }}</p>
                  </div>
                </div>
              </div>

            </div>


            <div class="grid sm:grid-cols-1 md:grid-cols-2 xl:grid-cols-2 gap-3">

              <div>
                <div class="sub-section" style="height: 100%">
                  <div class="item-row mb-5">
                    <p class="subject-name">Driver Name: </p>
                    <p class="subject-data">{{ arrivalDriver.name }}</p>
                  </div>
                  <div class="item-row mb-5">
                    <p class="subject-name">Mobile Number: </p>
                    <p class="subject-data">{{ arrivalDriver.mobileNo }}</p>
                  </div>
                  <div class="item-row mb-5" *ngIf="arrivalDriver.supplier !== '-'">
                    <p class="subject-name">Supplier: </p>
                    <p class="subject-data">{{ arrivalDriver.supplier }}</p>
                  </div>
                </div>
              </div>

              <div>
                <div class="sub-section" style="height: 100%"
                  *ngIf="transferForm.get('arrivalDetails.driverCategory').value === 'OUTSOURCE_DRIVER'">
                  <div class="item-row mb-5">
                    <p class="subject-name">Vehicle Model: </p>
                    <p class="subject-data">{{ this.arrivalVehicle.model }}</p>
                  </div>
                  <div class="item-row mb-5">
                    <p class="subject-name">Registration Number: </p>
                    <p class="subject-data">{{ this.arrivalVehicle.registrationNo }}</p>
                  </div>
                </div>
              </div>


            </div>


          </div>
        </form>
      </div>
    </nz-card>
  </section>

  <section id="departure-allocation-details"
    *ngIf="transferForm.get('bookingDetails.bookingCategory').value === 'Departure'||transferForm.get('tourDetails.departureCheck').value === true"
    class="mt-10">
    <nz-card>
      <div>
        <h5 class="text-primary">Departure Allocation Details</h5>
        <div class="flex items-center gap-3 mt-4">
          <button (click)="refreshVehicles()" class="px-[5px]" nz-button nzType="primary"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-rotate-cw"><path d="M21 12a9 9 0 1 1-9-9c2.52 0 4.93 1 6.74 2.74L21 8"/><path d="M21 3v5h-5"/></svg>
          </button>
          <h6 class="font-normal">Refresh before you allocate the vehicle</h6>
         </div>

        <form nz-form [formGroup]="transferForm">

          <div formGroupName="departureDetails" class="mt-5 grid sm:grid-cols-1 md:grid-cols-2 xl:grid-cols-2 gap-3">
            <div class="grid sm:grid-cols-1 md:grid-cols-2 xl:grid-cols-2 gap-3">

              <nz-form-item class="grid grid-flow-row content-start">
                <nz-form-label formControlName="allocatedVehicle" nzRequired>Allocated Vehicle</nz-form-label>
                <nz-form-control [nzErrorTip]="allocatedVehicleDeparture">
                  <nz-select nzPlaceHolder="Select Vehicle" nzAllowClear nzShowSearch
                    (nzOnSearch)="onSearchAllocatedVehicleDep($event)" (ngModelChange)="getFleetVehicleDep($event)"
                    formControlName="allocatedVehicle">
                    <nz-option *ngFor="let op of fleetsOptionsDepartureFiltered" nzValue="{{op._id}}"
                      nzLabel="{{op.vehicleName}}" [nzDisabled]="disableDepartureSelectedVehicle(op._id)"></nz-option>
                    <!--                    <nz-option nzCustomContent *ngFor="let op of fleetsOptionsDepartureFiltered" nzValue="{{op._id}}" nzLabel="{{op.vehicleName}}">-->
                    <!--                      <div class="flex items-center fleet-availability-status">-->
                    <!--                        <div [nz-tooltip]="getVehicleAvailabilityIcon(op.availabilityStatus)?.label" class="vehicle-status-mark {{getVehicleAvailabilityIcon(op.availabilityStatus)?.bgColor}}"></div>-->
                    <!--                        <div>{{op.vehicleName}}</div>-->
                    <!--                      </div>-->
                    <!--                    </nz-option>-->
                  </nz-select>
                </nz-form-control>
                <ng-template #allocatedVehicleDeparture>
                </ng-template>
                <p class="my-2 text-primary text-sm" *ngIf="fleetsFetchingDep">Loading...</p>
              </nz-form-item>


            </div>

            <div class="grid sm:grid-cols-1 md:grid-cols-2 xl:grid-cols-2 gap-3">

              <nz-form-item class="grid grid-flow-row content-start">
                <nz-form-label nzRequired>Driver Category</nz-form-label>
                <nz-form-control [nzErrorTip]="driverCategoryDeparture">
                  <nz-select nzPlaceHolder="Select Vehicle" formControlName="driverCategory"
                    (ngModelChange)="getDriverOptionsDep($event)">
                    <nz-option nzLabel="SR Driver" nzValue="SR_DRIVER"></nz-option>
                    <nz-option nzLabel="Outsourced driver" nzValue="OUTSOURCE_DRIVER"></nz-option>
                  </nz-select>
                </nz-form-control>
                <ng-template #driverCategoryDeparture>
                </ng-template>
              </nz-form-item>

              <div></div>
              <nz-form-item class="grid grid-flow-row content-start"
                *ngIf="transferForm.get('departureDetails.driverCategory').value !== null">
                <div class="flex items-center gap-3 mt-4">
                  <button (click)="refreshDrivers() " class="px-[5px]" nz-button nzType="primary"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-rotate-cw"><path d="M21 12a9 9 0 1 1-9-9c2.52 0 4.93 1 6.74 2.74L21 8"/><path d="M21 3v5h-5"/></svg>
                  </button>
                  <h6 class="font-normal">Refresh before you allocate the driver</h6>
                 </div>
                <nz-form-label nzRequired>Allocate Driver</nz-form-label>
                <nz-form-control [nzErrorTip]="allocateDriverDeparture">
                  <nz-select nzPlaceHolder="Select Driver" formControlName="allocateDriver" nzAllowClear nzShowSearch
                    (nzOnSearch)="onSearchDriverDep($event)"
                    (ngModelChange)="getSupplierVehiclesDeparture($event);getDriverDep($event)">
                    <!--                    <nz-option *ngFor="let op of driverOptionsDepFiltered" nzValue="{{op._id}}"-->
                    <!--                               nzLabel="{{op.fullName}}"></nz-option>-->
                    <nz-option nzCustomContent *ngFor="let op of driverOptionsDepFiltered" nzValue="{{op._id}}"
                      [nzLabel]="op.fullName">
                      <div class="flex items-center driver-availability-status">
                        <div [nz-tooltip]="getDriverAvailabilityIcon(op.driverAvailability)?.label"
                          class="vehicle-status-mark {{getDriverAvailabilityIcon(op.driverAvailability)?.bgColor}}">
                        </div>
                        <div>{{op.fullName}}</div>
                      </div>
                    </nz-option>
                  </nz-select>
                </nz-form-control>
                <ng-template #allocateDriverDeparture>
                </ng-template>
                <p class="my-2 text-primary text-sm" *ngIf="driversFetchingDep">Loading...</p>
              </nz-form-item>

              <nz-form-item class="grid grid-flow-row content-start"
                *ngIf="transferForm.get('departureDetails.driverCategory').value !== null">
                <nz-form-control>
                  <button (click)="showAddDriverPopup()" (keydown.enter)="$event.preventDefault()"
                    class="outline-button mt-9 custom-btn_add" nz-button nzType="default">Add New
                    Driver
                  </button>
                </nz-form-control>
              </nz-form-item>


              <nz-form-item class="grid grid-flow-row content-start"
                *ngIf="transferForm.get('departureDetails.driverCategory').value === 'OUTSOURCE_DRIVER'">
                <nz-form-label nzRequired>Allocate Vehicle</nz-form-label>
                <nz-form-control [nzErrorTip]="allocateVehicleDeparture">
                  <nz-select nzPlaceHolder="Select Vehicle" nzAllowClear nzShowSearch
                    (nzOnSearch)="onSearchSupplierVehicleDep($event)" formControlName="allocateVehicle"
                    (ngModelChange)="getSupplierVehicleDep($event)">
                    <nz-option *ngFor="let op of supplierVehicleOptionsDepartureFiltered" nzValue="{{op?._id}}"
                      nzLabel="{{op?.registerNumber}} | {{op?.vehicleModel}}"></nz-option>
                  </nz-select>
                </nz-form-control>
                <ng-template #allocateVehicleDeparture>
                </ng-template>
                <p class="my-2 text-primary text-sm" *ngIf="supplierVehiclesFetchingDep">Loading...</p>
              </nz-form-item>

              <nz-form-item class="grid grid-flow-row content-start"
                *ngIf="transferForm.get('departureDetails.driverCategory').value === 'OUTSOURCE_DRIVER'">
                <nz-form-control>
                  <button (click)="showAddVehiclePopup()"
                    [disabled]="this.transferForm.get('departureDetails.allocateDriver').value === null"
                    (keydown.enter)="$event.preventDefault()" class="outline-button mt-9" nz-button nzType="default">Add
                    New
                    Vehicle
                  </button>
                </nz-form-control>
              </nz-form-item>


              <nz-form-item class="grid grid-flow-row content-start"
                *ngIf="transferForm.get('departureDetails.driverCategory').value === 'OUTSOURCE_DRIVER'">
                <nz-form-label nzRequired>Outsourced Rate</nz-form-label>
                <nz-form-control [nzErrorTip]="OutsourcedDeparture">
                  <nz-input-number-group [nzAddOnAfter]="depositAddOnAfterTemplate">
                    <nz-input-number formControlName="outsourcedRate" [nzPlaceHolder]="'Enter Number'" [nzStep]="1"
                      [nzMin]="0"></nz-input-number>
                  </nz-input-number-group>
                  <ng-template #depositAddOnAfterTemplate>
                    <nz-select formControlName="outsourcedRateCurrency" [nzPlaceHolder]="'...'" style="width: 75px">
                      <nz-option *ngFor="let op of currencyOptions" [nzValue]="op._id"
                        [nzLabel]="op.currencyCode"></nz-option>
                    </nz-select>
                  </ng-template>
                </nz-form-control>
                <ng-template #OutsourcedDeparture>
                </ng-template>
              </nz-form-item>

            </div>

            <div class="grid sm:grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-3">

              <div *ngIf="transferForm.get('departureDetails.driverCategory').value !== 'OUTSOURCE_DRIVER'">
                <div class="sub-section" style="height: 100%">
                  <img width="90%" [src]="this.depVehicle.image" alt="image">
                </div>
              </div>

              <div *ngIf="transferForm.get('departureDetails.driverCategory').value !== 'OUTSOURCE_DRIVER'">
                <div style="height: 100%">
                  <div class="mb-5 mt-5">
                    <p class="subject-name">Registration Number</p>
                    <p class="subject-data">{{ this.depVehicle.registrationNo }}</p>
                  </div>
                </div>
              </div>

              <div *ngIf="transferForm.get('departureDetails.driverCategory').value !== 'OUTSOURCE_DRIVER'">
                <div style="height: 100%">
                  <div class="mb-5 mt-5">
                    <p class="subject-name">No. Of Seats</p>
                    <p class="subject-data">{{ this.depVehicle.seats }}</p>
                  </div>
                </div>
              </div>

            </div>


            <div class="grid sm:grid-cols-1 md:grid-cols-2 xl:grid-cols-2 gap-3" style="min-height: 200px">

              <div>
                <div class="sub-section" style="height: 100%">
                  <div class="item-row mb-5">
                    <p class="subject-name">Driver Name: </p>
                    <p class="subject-data">{{ depDriver.name }}</p>
                  </div>
                  <div class="item-row mb-5">
                    <p class="subject-name">Mobile Number: </p>
                    <p class="subject-data">{{ depDriver.mobileNo }}</p>
                  </div>
                  <div class="item-row mb-5" *ngIf="depDriver.supplier !== '-'">
                    <p class="subject-name">Supplier: </p>
                    <p class="subject-data">{{ depDriver.supplier }}</p>
                  </div>
                </div>
              </div>

              <div>
                <div class="sub-section" style="height: 100%"
                  *ngIf="transferForm.get('departureDetails.driverCategory').value === 'OUTSOURCE_DRIVER'">
                  <div class="item-row mb-5">
                    <p class="subject-name">Vehicle Model: </p>
                    <p class="subject-data">{{ this.depVehicle.model }}</p>
                  </div>
                  <div class="item-row mb-5">
                    <p class="subject-name">Registration Number: </p>
                    <p class="subject-data">{{ this.depVehicle.registrationNo }}</p>
                  </div>
                </div>
              </div>


            </div>


          </div>
        </form>
      </div>
    </nz-card>
  </section>


  <section id="booking-cost-details" class="mt-6">
    <nz-card>
      <div>
        <h5 class="text-primary">Transfer Booking Cost</h5>

        <form nz-form [formGroup]="transferForm">

          <div class="grid xl:grid-cols-2 gap-2" formGroupName="bookingCost">

            <div>

              <nz-form-item class="grid grid-flow-row content-start">
                <nz-form-label nzFor="depositId" nzRequired>Transfer Cost</nz-form-label>
                <nz-form-control [nzErrorTip]="transferError">
                  <nz-input-number-group [nzAddOnAfter]="depositAddOnAfterTemplate">
                    <nz-input-number id="transferId" formControlName="transferCost" [nzPlaceHolder]="'Enter Number'"
                      [nzStep]="1" [nzMin]="0"></nz-input-number>
                  </nz-input-number-group>
                  <ng-template #depositAddOnAfterTemplate>
                    <nz-select id="transferCurrencyId" formControlName="transferCurrency" [nzPlaceHolder]="'...'"
                      style="width: 75px">
                      <nz-option *ngFor="let op of currencyOptions" [nzValue]="op._id"
                        [nzLabel]="op.currencyCode"></nz-option>
                    </nz-select>
                  </ng-template>
                </nz-form-control>
                <ng-template #transferError>
                  <span *ngIf="formErrors?.bookingCost?.transferCost?.required">Please enter value. </span>
                </ng-template>
              </nz-form-item>

            </div>

          </div>


          <h6 class="my-2">Extra Charges</h6>
          <div>
            <div class="grid xl:grid-cols-1 gap-2" formGroupName="bookingCost">
              <div>
                <div formArrayName="extraCharges" *ngFor="let extra of extraCharges.controls; let costIndex = index">
                  <div class="grid sm:grid-cols-5 gap-2">
                    <nz-form-label class="col-span-2" *ngIf="costIndex === 0" nzFor="chargeType" nzRequired>Charge Type
                    </nz-form-label>
                    <nz-form-label class="col-span-2" *ngIf="costIndex === 0" nzFor="chargeCost" nzRequired>Value
                    </nz-form-label>
                  </div>
                  <div class="grid sm:grid-cols-5 gap-6 sm:gap-2 my-1">
                    <nz-form-item [formGroupName]="costIndex" class="col-span-2 grid grid-flow-row content-start mb-0">
                      <!--                    <nz-form-label *ngIf="costIndex === 0" nzFor="chargeType" nzRequired>Charge Type</nz-form-label>-->
                      <nz-form-control [nzErrorTip]="chargeTypeError">
                        <nz-select class="w-full" formControlName="chargeType" nzPlaceHolder="Select Preference"
                          nzShowSearch nzAllowClear [nzDropdownRender]="renderTemplate">
                          <nz-option *ngFor="let item of chargesOptions" [nzLabel]="item" [nzValue]="item"></nz-option>
                        </nz-select>
                        <ng-template #renderTemplate>
                          <nz-divider></nz-divider>
                          <div class="flex flex-col justify-center mx-3">
                            <input type="text" nz-input #inputElement />
                            <a class="text-center m-1" (click)="addItem(inputElement)">
                              <span nz-icon nzType="plus"></span>
                              Add item
                            </a>
                          </div>
                        </ng-template>
                      </nz-form-control>
                      <ng-template #chargeTypeError>
                        <span *ngIf="formErrors?.bookingCost?.chargeType?.required">Please select charge type. </span>
                      </ng-template>
                    </nz-form-item>
                    <nz-form-item [formGroupName]="costIndex" class="col-span-2 grid grid-flow-row content-start mb-0">
                      <!--                    <nz-form-label *ngIf="costIndex === 0" nzFor="chargeCost" nzRequired>Value</nz-form-label>-->
                      <nz-form-control class="w-full" [nzErrorTip]="chargeCostError">
                        <!--&lt;!&ndash;                      <nz-input-group [nzAddOnAfter]="deleteButton">&ndash;&gt;-->
                        <!--                        <nz-input-number class="w-full" formControlName="chargeCost"-->
                        <!--                                         nzPlaceHolder="Enter Number"></nz-input-number>-->
                        <!--                      </nz-input-group>-->
                        <nz-input-number-group class="w-full" [nzAddOnAfter]="extraAddOnAfterTemplate">
                          <nz-input-number formControlName="amount" [nzPlaceHolder]="'Enter Number'" [nzStep]="1"
                            [nzMin]="0"></nz-input-number>
                        </nz-input-number-group>
                        <ng-template #extraAddOnAfterTemplate>
                          <nz-select formControlName="currency" [nzPlaceHolder]="'...'" style="width: 75px">
                            <nz-option *ngFor="let op of currencyOptions" [nzValue]="op._id"
                              [nzLabel]="op.currencyCode"></nz-option>
                          </nz-select>
                        </ng-template>
                        <!--                    <input nz-input type="text" formControlName="chargeCost" placeholder="Enter Number"/>-->
                      </nz-form-control>
                      <ng-template #chargeCostError>
                        <span *ngIf="formErrors?.bookingCost?.chargeCost?.required">Please enter value. </span>
                      </ng-template>
                      <ng-template>
                      </ng-template>
                    </nz-form-item>
                    <button class="col-span-1" nz-button nzType="text" nzDanger (click)="deleteExtraCharges(costIndex)"
                      (keydown.enter)="$event.preventDefault()"><span nz-icon nzType="delete" nzTheme="outline"></span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <button class="outline-button mt-2" nz-button nzType="default" nz-popconfirm (click)="addExtraCharge()">
                <span nz-icon nzType="plus" nzTheme="outline" (keydown.enter)="$event.preventDefault()"></span></button>
            </div>
            <div class="flex mt-3">
              <p>Total Extra Charges - </p>
              <p class="ml-3">{{ totalExtraChargesInLKR | number:'1.2-2' }} LKR</p>
            </div>
            <nz-divider></nz-divider>
          </div>
        </form>
      </div>
    </nz-card>
  </section>


  <section id="other-information" class="mt-6">
    <nz-card>
      <div>
        <h5 class="text-primary">Other Information</h5>

        <form nz-form [formGroup]="transferForm">

          <div formGroupName="otherInformation" class="mt-5 grid sm:grid-cols-1 md:grid-cols-2 xl:grid-cols-2 gap-3">

            <nz-form-item class="grid grid-flow-row content-start">
              <nz-form-label>Special Instructions</nz-form-label>
              <nz-form-control>
                <textarea rows="6" nz-input PlaceHolder="Add Notes here"
                  formControlName="specialInstructions"></textarea>
              </nz-form-control>
            </nz-form-item>

          </div>

        </form>

      </div>
    </nz-card>
  </section>


  <section id="buttons" class="mt-6">
    <nz-card>
      <div class="flex justify-end sm:justify-end">
        <a nz-popconfirm
          nzPopconfirmTitle="Are you sure you want to cancel this Transfer Booking? You will lost all data."
          nzPopconfirmPlacement="bottom" (nzOnConfirm)="bookingCancel()" (nzOnCancel)="cancel()">
          <button class="outline-button mr-3" nz-button nzType="default" (nzOnConfirm)="bookingCancel()">Cancel
          </button>
        </a>
        <a nz-popconfirm
          nzPopconfirmTitle="{{reservationId ? 'Are you sure you want to save this information' : 'Are you sure you want to add new Booking?'}}"
          nzPopconfirmPlacement="bottom" (nzOnConfirm)="onSubmit()" (nzOnCancel)="cancel()">
          <button nz-button nzType="primary" [disabled]="transferForm.invalid">Update Booking
          </button>
        </a>
      </div>
    </nz-card>
  </section>
</div>
<div [ngClass]="loading ? 'block' : 'hidden'">
  <app-edit-view-skeleton-template></app-edit-view-skeleton-template>
</div>

<app-add-customer-popup [isVisible]="visibleAddCustomerPopup"
  (addEditCustomerOnChange)="onGetAddCustomerChange($event)"></app-add-customer-popup>
<app-add-agent-popup [isVisible]="visibleAddAgentPopup"
  (addEditAgentOnChange)="onGetAddAgentChange($event)"></app-add-agent-popup>

<app-add-driver-popup [isVisible]="visibleAddDriverPopup"
  (addEditDriverOnChange)="onGetAddDriverChange($event)"></app-add-driver-popup>

<app-vehicle-details-form [isVisible]="visibleAddVehiclePopup" [supplier]="selectedSupplierId"
  (addVehicleOnChange)="onGetAddVehicleChange($event)"></app-vehicle-details-form>